import React from "react";
import { Container } from "reactstrap";

// reactstrap components

// core components

function MainHeader(props) {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("product-page");
    return function cleanup() {
      document.body.classList.remove("product-page");
    };
  });
  return (
    <>
      <div
        className="page-header page-header-xs"
        style={{
          backgroundImage: "url(" + require("assets/img/galaxycover2.jpeg") + ")"}}
      >
   
   <div className="filter" />
        <div className="content-center">
          <Container>
            <div className="motto">
              <h1 className="title">{props.title}</h1>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default MainHeader;
